import AccommodationIcon from "src/img/noticeboard/white-check-in-accommodation.svg";
import CultureIcon from "src/img/noticeboard/white-check-in-culture.svg";
import FoodDrinkIcon from "src/img/noticeboard/white-check-in-food-drink.svg";
import LocationIcon from "src/img/noticeboard/white-check-in-location.svg";
import ShoppingIcon from "src/img/noticeboard/white-check-in-shopping.svg";

export const CHECK_IN_CATEGORY = {
    FOOD_AND_DRINK: "food_and_drink",
    SHOPPING: "shopping",
    CULTURE: "culture",
    ACCOMMODATION: "accommodation",
    LOCATION: "location"
};

export const CHECK_IN_CATEGORY_LABEL = {
    [CHECK_IN_CATEGORY.FOOD_AND_DRINK]: "Food & Drink",
    [CHECK_IN_CATEGORY.SHOPPING]: "Shopping",
    [CHECK_IN_CATEGORY.CULTURE]: "Culture",
    [CHECK_IN_CATEGORY.ACCOMMODATION]: "Accommodation",
    [CHECK_IN_CATEGORY.LOCATION]: "Location"
};

export const CHECK_IN_CATEGORIES = {
    [CHECK_IN_CATEGORY.FOOD_AND_DRINK]: {
        id: CHECK_IN_CATEGORY.FOOD_AND_DRINK,
        label: CHECK_IN_CATEGORY_LABEL[CHECK_IN_CATEGORY.FOOD_AND_DRINK],
        icon: FoodDrinkIcon,
        color: "#D84A2B",
        softColor: "rgba(216, 74, 43, 0.12)",
        showBadge: true,
        googlePlaceTypes: [
            "restaurant",
            "cafe",
            "bar",
            "bakery",
            "meal_takeaway",
            "meal_delivery"
        ],
        nearbySearchTypes: [
            "restaurant",
            "cafe",
            "bar",
            "bakery",
            "meal_takeaway"
        ]
    },

    [CHECK_IN_CATEGORY.SHOPPING]: {
        id: CHECK_IN_CATEGORY.SHOPPING,
        label: CHECK_IN_CATEGORY_LABEL[CHECK_IN_CATEGORY.SHOPPING],
        icon: ShoppingIcon,
        color: "#1F8A70",
        softColor: "rgba(31, 138, 112, 0.13)",
        showBadge: true,
        googlePlaceTypes: [
            "shopping_mall",
            "store",
            "supermarket",
            "department_store",
            "clothing_store",
            "shoe_store",
            "book_store"
        ],
        nearbySearchTypes: [
            "shopping_mall",
            "store",
            "supermarket",
            "department_store",
            "clothing_store",
            "shoe_store",
            "book_store"
        ]
    },

    [CHECK_IN_CATEGORY.CULTURE]: {
        id: CHECK_IN_CATEGORY.CULTURE,
        label: CHECK_IN_CATEGORY_LABEL[CHECK_IN_CATEGORY.CULTURE],
        icon: CultureIcon,
        color: "#6B4CC2",
        softColor: "rgba(107, 76, 194, 0.13)",
        showBadge: true,
        googlePlaceTypes: [
            "museum",
            "art_gallery",
            "tourist_attraction",
            "movie_theater",
            "performing_arts_theater"
        ],
        nearbySearchTypes: [
            "museum",
            "art_gallery",
            "tourist_attraction",
            "movie_theater",
            "performing_arts_theater"
        ]
    },

    [CHECK_IN_CATEGORY.ACCOMMODATION]: {
        id: CHECK_IN_CATEGORY.ACCOMMODATION,
        label: CHECK_IN_CATEGORY_LABEL[CHECK_IN_CATEGORY.ACCOMMODATION],
        icon: AccommodationIcon,
        color: "#B86E16",
        softColor: "rgba(184, 110, 22, 0.13)",
        showBadge: true,
        googlePlaceTypes: [
            "lodging",
            "hotel",
            "motel",
            "resort_hotel"
        ],
        nearbySearchTypes: [
            "lodging",
            "hotel",
            "motel"
        ]
    },

    [CHECK_IN_CATEGORY.LOCATION]: {
        id: CHECK_IN_CATEGORY.LOCATION,
        label: CHECK_IN_CATEGORY_LABEL[CHECK_IN_CATEGORY.LOCATION],
        icon: LocationIcon,
        color: "#2F6FDB",
        softColor: "rgba(47, 111, 219, 0.12)",
        showBadge: false,
        googlePlaceTypes: [
            "park",
            "beach",
            "monument",
            "tourist_attraction",
            "historical_place",
            "cultural_landmark"
        ],
        nearbySearchTypes: [
            "tourist_attraction",
            "park",
            "museum",
            "art_gallery",
            "restaurant",
            "cafe",
            "bar",
            "bakery",
            "shopping_mall",
            "store",
            "lodging",
            "hotel"
        ]
    }
};

export const CHECK_IN_CATEGORY_LIST = Object.values(CHECK_IN_CATEGORIES);

export const getCheckInCategory = category =>
    CHECK_IN_CATEGORIES[category] ||
    CHECK_IN_CATEGORIES[CHECK_IN_CATEGORY.LOCATION];

export const isLocationCheckIn = category =>
    category === CHECK_IN_CATEGORY.LOCATION;

export const shouldShowCheckInCategory = category =>
    getCheckInCategory(category).showBadge;

export const mapGooglePlaceTypesToCheckInCategory = (placeTypes = []) => {
    const types = new Set(placeTypes);
    const matchedCategory = CHECK_IN_CATEGORY_LIST.find(category =>
        category.googlePlaceTypes.some(type => types.has(type))
    );

    return matchedCategory?.id || CHECK_IN_CATEGORY.LOCATION;
};

export const hasValidCheckIn = checkIn =>
    Boolean(
        checkIn &&
        checkIn.category &&
        checkIn.placeName &&
        checkIn.placeId &&
        checkIn.provider &&
        checkIn.latitude !== null &&
        checkIn.latitude !== undefined &&
        checkIn.longitude !== null &&
        checkIn.longitude !== undefined
    );

export const normaliseCheckInForRequest = checkIn => {
    if (!hasValidCheckIn(checkIn)) {
        return null;
    }

    return {
        category: checkIn.category,
        placeName: checkIn.placeName,
        placeId: checkIn.placeId,
        formattedAddress: checkIn.formattedAddress || "",
        latitude: Number(checkIn.latitude),
        longitude: Number(checkIn.longitude),
        provider: checkIn.provider,
        providerPlaceTypes: checkIn.providerPlaceTypes || [],
        placeImageReference: checkIn.placeImageReference || ""
    };
};

export const checkInCountText = count => {
    if (!count) {
        return "";
    }

    return `${count} ${count === 1 ? "other" : "others"} checked in here`;
};
